import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { useParams } from "react-router-dom";
import { auth } from "../helpers/firebaseConfig";
import { useAuth } from "./AuthProvider";
import "./auth.css";

export default function EditorLayout({ children, title = "Podcast Editor", contextLabel = "Podcast", contextValue, hideHeader = false, dark = false }) {
  const { user } = useAuth();
  const params = useParams();
  const [isSigningOut, setIsSigningOut] = useState(false);
  const [error, setError] = useState("");
  const identity = user?.displayName || user?.email || "Signed-in user";
  const resolvedContextValue = contextValue ?? params.podcastId ?? params.simulationId ?? "";

  const logout = async () => {
    setIsSigningOut(true);
    setError("");
    try {
      await signOut(auth);
    } catch (err) {
      setError(String(err?.message || "Could not log out."));
      setIsSigningOut(false);
    }
  };

  return (
    <div className={`editor-authShell${hideHeader ? " isHeaderless" : ""}${dark ? " isDark" : ""}`}>
      {!hideHeader ? (
        <header className="editor-authBar">
          <div className="editor-authContext">
            <strong>{title}</strong>
            <span title={resolvedContextValue}>{resolvedContextValue ? `${contextLabel}: ${resolvedContextValue}` : ""}</span>
          </div>
          <div id="editor-toolbar-root" className="editor-authToolbar" />
          <div className="editor-authAccount">
            {user?.photoURL ? <img src={user.photoURL} alt="" referrerPolicy="no-referrer" /> : <div className="editor-authAvatar">{identity.charAt(0).toUpperCase()}</div>}
            <div className="editor-authIdentity">
              <strong>{identity}</strong>
              {user?.displayName && user?.email ? <span>{user.email}</span> : null}
            </div>
            <button type="button" disabled={isSigningOut} onClick={logout}>{isSigningOut ? "Logging out…" : "Log out"}</button>
          </div>
        </header>
      ) : null}
      {error ? <div className="editor-authError" role="alert">{error}</div> : null}
      <div className="editor-authContent">{children}</div>
    </div>
  );
}
